import React from 'react'
import Header from "../components/layout/Header"
import Handbook from "../components/blocks/Handbook"
import Clients from "../components/blocks/Handbook/components/Clients"
import MedicalInstitutions from "../components/blocks/Handbook/components/MedicalInstitutions"
import classes from "../components/layout/Layout/Layout.module.scss"

export default function HandbookPage() {

  const blocks = [
    {
      title: "Клиенты",
      block: <Clients/>
    },
    {
      title: "Адрес",
      block: <MedicalInstitutions/>
    }
  ]

  return (
    <>
      <div className={classes.header}>
        <Header title={'Справочник'} showUser={true}/>
      </div>
      <div className={classes.content}>
        <Handbook blocks={blocks}/>
      </div>
    </>
  )
}